export const restaurantCategories = [
  { src: 'https://content.jdmagicbox.com/comp/guntur/p6/9999px863.x863.181101182829.y8p6/catalogue/bismillah-family-ac-restaurant-ponnur-guntur-restaurants-ppzmmdzkp7.jpg', alt: 'Biryani' },
  { src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0Lj3_8eh0xYQLDhyh1pYwOF6l00mL7hIfww&s', alt: 'Pizza' },
  { src: 'https://www.cookwithmanali.com/wp-content/uploads/2020/05/Masala-Dosa.jpg', alt: 'Dosa' },
  { src: 'https://www.indianhealthyrecipes.com/wp-content/uploads/2022/04/idli-recipe.jpg', alt: 'Idli' },
  { src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRIxuDVSOHhkXWd-reUJpUbXg7fK1dN_MD7Zg&s', alt: 'Veg Thali' },
  { src: 'https://www.sharmispassions.com/wp-content/uploads/2023/08/sweet-lassi5.jpg', alt: 'Lassi' },
  { src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTXgdqwalEV0wkfilPZnKQoCq4OFaI3Tj5dRQ&s', alt: 'Salad' },
  { src: 'https://www.myplantifulcooking.com/wp-content/uploads/2021/12/vegan-roti-featured-500x500.jpg', alt: 'Roti' },
  // Add more here, e.g.:
  // { src: 'your-fries-image-url', alt: 'Fries' },
];

export const groceryCategories = [
  { src: 'https://m.media-amazon.com/images/I/71xpepHmE8L._AC_UF1000,1000_QL80_.jpg', alt: 'Rice' },
  { src: 'https://assets.clevelandclinic.org/transform/cd71f4bd-81d4-45d8-a450-74df78e4477a/Apples-184940975-770x533-1_jpg', alt: 'Apples' },
  { src: 'https://images.indianexpress.com/2022/08/salt-edit.jpg', alt: 'Salt' },
  { src: 'https://90degrees.in/cdn/shop/files/1copy_de20fde9-7283-46c1-826c-23eb28e3ee30.jpg?v=1689306365&width=360', alt: 'Bread' },
  { src: 'https://priyafoods.com/cdn/shop/products/MangoAvakayaWG300g.jpg?v=1689145579', alt: 'Pickle' },
  { src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLWh-E-5rCitwZiTaKzesMB6kupUh0TRu1FQ&s', alt: 'Banana' },
  { src: 'https://www.quickpantry.in/cdn/shop/products/lay-s-chile-limon-potato-chips-32-g-quick-pantry.jpg?v=1710539171', alt: 'Lays' },
  { src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKRc1vsNojeMRzLpjSF-_g3ihYlGBwVgpNqw&s', alt: 'Milk' },
  // Add more here
];

export const cloudKitchenCategories = [
  { src: 'https://content.jdmagicbox.com/comp/guntur/p6/9999px863.x863.181101182829.y8p6/catalogue/bismillah-family-ac-restaurant-ponnur-guntur-restaurants-ppzmmdzkp7.jpg', alt: 'Biryani' },
  { src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0Lj3_8eh0xYQLDhyh1pYwOF6l00mL7hIfww&s', alt: 'Pizza' },
  { src: 'https://www.cookwithmanali.com/wp-content/uploads/2020/05/Masala-Dosa.jpg', alt: 'Dosa' },
  { src: 'https://www.indianhealthyrecipes.com/wp-content/uploads/2022/04/idli-recipe.jpg', alt: 'Idli' },
  { src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRIxuDVSOHhkXWd-reUJpUbXg7fK1dN_MD7Zg&s', alt: 'Veg Thali' },
  { src: 'https://www.sharmispassions.com/wp-content/uploads/2023/08/sweet-lassi5.jpg', alt: 'Lassi' },
  { src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTXgdqwalEV0wkfilPZnKQoCq4OFaI3Tj5dRQ&s', alt: 'Salad' },
  { src: 'https://www.myplantifulcooking.com/wp-content/uploads/2021/12/vegan-roti-featured-500x500.jpg', alt: 'Roti' },
  // Add more here, e.g.:
];



